<div class="mr-[14.5rem] text-left relative flex flex-grow flex-wrap left-[14.5rem] scrollbar-none box-border">
  @if (session.isMobileDevice && session.menuMobileLeftVisible) {
    <ism-tutorial-menu class="mx-auto p-4 w-11/12 top-0 left-0 bottom-0 text-1.25 flex flex-col navbarLeft8 scrollbar-none absolute z-20 rounded-l-lg bg-opacity-75 overflow-y-scroll"> </ism-tutorial-menu>
  }
  <!-- -->
  @else if (!session.isMobileDevice) {
    <ism-tutorial-menu class="px-2 w-fit min-w-[240px] text-1.25 fixed top-[3rem] left-0 bottom-0 flex flex-col navbarLeft8 scrollbar-none overflow-y-scroll"> </ism-tutorial-menu>
  }

  <div id="_TUTORIAL-BASE_" class="px-4 w-full border-0 border-white flex flex-col flex-wrap overflow-scroll ism-white scrollbar-none">
    <router-outlet></router-outlet>
    <div class="h-8"></div>
  </div>
</div>
